(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zardo-all-eras-directory"] && !Shopify.designMode) return;
  try {
    
  const eraMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const eraReveals = new Map();
  let eraRevealObserver;
  const revealEraCard = (card, delay = 0) => {
    if (card.dataset.eraRevealed) return;
    card.dataset.eraRevealed = 'true';
    eraRevealObserver?.unobserve(card);
    if (eraMotion.matches || card.getBoundingClientRect().bottom <= 0) return;
    const animation = card.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], {
      duration: 560,
      delay,
      easing: 'cubic-bezier(.2, .7, .3, 1)',
      fill: 'backwards'
    });
    eraReveals.set(card, animation);
    const forget = () => eraReveals.delete(card);
    animation.addEventListener('finish', forget, { once: true });
    animation.addEventListener('cancel', forget, { once: true });
  };
  const initializeEraReveals = (root) => {
    if (eraMotion.matches) return;
    try {
      eraRevealObserver ||= new IntersectionObserver(entries => {
        let sequence = 0;
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= .2) revealEraCard(entry.target, Math.min(sequence++ * 40, 80));
        });
      }, { threshold: .2, rootMargin: '0px 0px -40px 0px' });
      root.querySelectorAll('.zardo-era-directory__card').forEach(card => {
        if (card.dataset.eraRevealObserved) return;
        card.dataset.eraRevealObserved = 'true';
        if (card.getBoundingClientRect().top < innerHeight) card.dataset.eraRevealed = 'true';
        else eraRevealObserver.observe(card);
        card.closest('.zardo-era-directory').classList.add('is-era-reveal-ready');
        card.addEventListener('focus', () => {
          card.dataset.eraRevealed = 'true';
          eraRevealObserver?.unobserve(card);
          eraReveals.get(card)?.cancel();
        });
      });
    } catch {
      eraRevealObserver?.disconnect();
      document.querySelectorAll('.zardo-era-directory').forEach(directory => directory.classList.remove('is-era-reveal-ready'));
    }
  };
  eraMotion.addEventListener('change', () => {
    if (eraMotion.matches) {
      eraRevealObserver?.disconnect();
      eraReveals.forEach(animation => animation.cancel());
      document.querySelectorAll('.zardo-era-directory__card').forEach(card => { card.dataset.eraRevealed = 'true'; });
      document.querySelectorAll('.zardo-era-directory').forEach(directory => directory.classList.remove('is-era-reveal-ready'));
    }
  });
  document.addEventListener('shopify:section:load', event => initializeEraReveals(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.zardo-era-directory__card').forEach(card => {
      eraRevealObserver?.unobserve(card);
      eraReveals.get(card)?.cancel();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeEraReveals(document), { once: true });
  else initializeEraReveals(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zardo-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zardo-countdown')) {
    customElements.define('zardo-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end || '');
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach((element) => {
          this.units[element.dataset.unit] = element;
        });
        this.status = this.querySelector('[data-countdown-status]');
        this.daysGroup = this.querySelector('[data-countdown-days]');
        this.expiredMessage = this.querySelector('[data-countdown-expired]');
        this.lastMinute = null;
        this.events = new AbortController();
        const { signal } = this.events;
        document.addEventListener('visibilitychange', () => this.update(), { signal });
        window.addEventListener('pageshow', () => this.update(), { signal });
        this.update();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
      }

      update() {
        clearTimeout(this.timer);
        if (!Number.isFinite(this.end) || document.visibilityState === 'hidden') return;

        const remaining = this.end - Date.now();
        this.toggleAttribute('data-urgent', this.dataset.urgentWindow === '24' && remaining > 0 && remaining <= 24 * 60 * 60 * 1000);
        if (remaining <= 0) {
          this.expire();
          return;
        }

        const total = Math.floor(remaining / 1000);
        const parts = {
          days: Math.floor(total / 86400),
          hours: Math.floor((total % 86400) / 3600),
          minutes: Math.floor((total % 3600) / 60),
          seconds: total % 60,
        };
        const shown = { ...parts };
        if (!this.units.days) shown.hours += parts.days * 24;
        if (this.daysGroup) this.daysGroup.hidden = parts.days === 0;
        this.style.setProperty('--zardo-countdown-unit-count', Object.keys(this.units).length - (this.daysGroup?.hidden ? 1 : 0));

        Object.entries(this.units).forEach(([unit, element]) => {
          this.setValue(element, String(shown[unit]).padStart(2, '0'));
        });

        const minute = Math.floor(remaining / 60000);
        if (this.status && minute !== this.lastMinute) {
          this.lastMinute = minute;
          let template = this.dataset.status || '';
          if (parts.days === 0) template = template.replace(/\[days\][^,]*,\s*/, '');
          this.status.textContent = template
            .replace('[days]', parts.days)
            .replace('[hours]', parts.hours)
            .replace('[minutes]', parts.minutes);
        }

        const step = this.units.seconds ? 1000 : 60000;
        const delay = Math.min(remaining, step - (Date.now() % step)) + 20;
        this.timer = setTimeout(() => this.update(), delay);
      }

      setValue(element, value) {
        if (element.dataset.value === value) return;
        element.dataset.value = value;
        (element.firstElementChild || element).textContent = value;
      }

      expire() {
        Object.values(this.units).forEach((element) => this.setValue(element, '00'));
        if (this.daysGroup) this.daysGroup.hidden = true;
        this.style.setProperty('--zardo-countdown-unit-count', Object.keys(this.units).length - (this.daysGroup ? 1 : 0));
        this.toggleAttribute('data-expired', true);
        if (this.status) this.status.textContent = this.expiredMessage?.textContent.trim() || '';

        if (this.dataset.expiredMode === 'hide' && !window.Shopify?.designMode) {
          const section = this.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
      }
    });
  }

  if (!window.zardoCountdownKlaviyoBound) {
    window.zardoCountdownKlaviyoBound = true;

    const klaviyoReady = () => !!(window._klOnsite && typeof window._klOnsite.openForm === 'function');
    const openKlaviyo = (formId) => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    };
    const openNotifyDialog = (dialogId) => {
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (!dialog.open) dialog.showModal();
      const focusTarget = dialog.querySelector('[data-notify-success], input[type="email"]');
      if (focusTarget) focusTarget.focus();
      return true;
    };

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('dialog.zardo-countdown-notify');
      if (dialog && event.target === dialog) {
        dialog.close();
        return;
      }

      const trigger = event.target.closest('[data-zardo-klaviyo-form]');
      if (!trigger) return;
      const formId = trigger.dataset.zardoKlaviyoForm;
      const fallbackId = trigger.dataset.zardoNotifyFallback;
      if (!formId && !fallbackId) return;
      event.preventDefault();

      if (!fallbackId) {
        openKlaviyo(formId);
        return;
      }
      if (formId && klaviyoReady()) {
        openKlaviyo(formId);
        return;
      }

      // Klaviyo is not running yet: blocked by an ad blocker, or still loading.
      // Give it a short grace period, then fall back to the built-in Shopify form.
      const started = Date.now();
      const settle = () => {
        if (formId && klaviyoReady()) {
          openKlaviyo(formId);
          return;
        }
        if (Date.now() - started < 1500) {
          setTimeout(settle, 100);
          return;
        }
        openNotifyDialog(fallbackId);
      };
      settle();
    });

    // Shopify redirects back with the form id as the hash after a successful signup:
    // reopen that dialog so the visitor sees the confirmation.
    const hash = window.location.hash.slice(1);
    if (hash) {
      const dialog = document.querySelector(`dialog.zardo-countdown-notify[data-notify-form="${CSS.escape(hash)}"]`);
      if (dialog && dialog.querySelector('[data-notify-success]')) openNotifyDialog(dialog.id);
    }
  }

  if (!customElements.get('zardo-countdown-media')) {
    customElements.define('zardo-countdown-media', class extends HTMLElement {
      connectedCallback() {
        this.templates = {
          desktop: this.querySelector('template[data-media="desktop"]'),
          mobile: this.querySelector('template[data-media="mobile"]'),
        };
        if (!this.templates.desktop && !this.templates.mobile) return;

        this.current = null;
        this.events = new AbortController();
        const { signal } = this.events;
        this.mobileQuery = window.matchMedia('(max-width: 699px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery.addEventListener('change', () => this.mount(), { signal });
        this.motionQuery.addEventListener('change', () => this.mount(), { signal });
        this.mount();
      }

      disconnectedCallback() {
        this.events?.abort();
      }

      mount() {
        let wanted = null;
        if (!this.motionQuery.matches) {
          if (this.mobileQuery.matches) {
            if (this.templates.mobile) wanted = 'mobile';
            else if (!this.hasAttribute('data-mobile-image') && this.templates.desktop) wanted = 'desktop';
          } else if (this.templates.desktop) {
            wanted = 'desktop';
          }
        }
        if (wanted === this.current) return;

        this.current = wanted;
        this.querySelector('video')?.remove();
        if (!wanted) return;

        const video = this.templates[wanted].content.firstElementChild.cloneNode(true);
        video.muted = true;
        this.append(video);
        const playing = video.play();
        if (playing) playing.catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zardo-home-eras-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeEraCarousel = root => {
    root.querySelectorAll('[data-zardo-era-carousel]').forEach(shell => {
      if (shell.dataset.eraReady) return;
      shell.dataset.eraReady = 'true';
      const track = shell.querySelector('[data-zardo-collection-track]');
      const previous = shell.querySelector('.zardo-collection-row__control--prev');
      const next = shell.querySelector('.zardo-collection-row__control--next');
      const scrollbarThumb = shell.querySelector('[data-zardo-era-scrollbar-thumb]');
      let scrollTarget = track.scrollLeft;
      let moving = false;
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (scrollbarThumb) {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const thumbWidth = Math.max(12, Math.min(100, track.clientWidth / track.scrollWidth * 100));
          const progress = max ? track.scrollLeft / max : 0;
          scrollbarThumb.style.width = `${thumbWidth}%`;
          scrollbarThumb.style.left = `${progress * (100 - thumbWidth)}%`;
        }
      };
      const move = direction => {
        const card = track.querySelector('a');
        const style = getComputedStyle(card);
        const step = card.getBoundingClientRect().width + parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0) + (parseFloat(getComputedStyle(track).columnGap) || 0);
        scrollTarget = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, (moving ? scrollTarget : track.scrollLeft) + step * direction));
        moving = true;
        track.scrollTo({ left: scrollTarget, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('scrollend', () => { moving = false; }, { passive: true });
      track.addEventListener('wheel', () => { moving = false; }, { passive: true });
      new ResizeObserver(update).observe(track);
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      let drag;
      let suppressClick = false;
      track.addEventListener('pointerdown', event => {
        moving = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, y: event.clientY, left: track.scrollLeft, moved: false };
        suppressClick = false;
      });
      track.addEventListener('pointermove', event => {
        if (!drag || !(event.buttons & 1)) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && (Math.abs(distance) < 8 || Math.abs(distance) < Math.abs(event.clientY - drag.y))) return;
        drag.moved = true;
        suppressClick = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
        track.scrollLeft = drag.left - distance;
        event.preventDefault();
      });
      const endDrag = () => {
        drag = null;
        track.classList.remove('is-dragging');
        window.setTimeout(() => { suppressClick = false; }, 150);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
      update();
    });
  };
  initializeEraCarousel(document);
  document.addEventListener('shopify:section:load', event => initializeEraCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zardo-set-navigation"] && !Shopify.designMode) return;
  try {
    
  // Chris, 2026-10-23 : barre de prix a deux poignees. Paliers plutot qu'une echelle lineaire, pour qu'on puisse
  // viser 20 $ comme 2 000 $. La poignee du haut tout a droite = sans maximum.
  const zardoPriceSteps = (cap) => [0, 5, 10, 15, 20, 25, 30, 40, 50, 60, 75, 100, 125, 150, 200, 250, 300, 400, 500, 750, 1000, 1500, 2000, 2500, 3000, 5000, 7500, 10000, 15000, 25000, 50000, 75000, 100000].filter((step) => step < cap).concat(Infinity);
  const zardoPricePaint = (fieldset, write) => {
    const steps = zardoPriceSteps(Number(fieldset.dataset.cap) || 10000);
    const top = steps.length - 1;
    const low = fieldset.querySelector('[data-price-range="min"]');
    const high = fieldset.querySelector('[data-price-range="max"]');
    low.max = high.max = String(top);
    let lo = Math.min(Number(low.value), top - 1);
    let hi = Math.max(Number(high.value), 1);
    if (lo >= hi) { if (document.activeElement === high) hi = lo + 1; else lo = hi - 1; }
    low.value = String(lo); high.value = String(hi);
    low.style.zIndex = lo >= top - 1 ? '3' : '';
    const money = (value) => '$' + value.toLocaleString('en-US');
    fieldset.querySelector('[data-price-label="min"]').textContent = money(steps[lo]);
    fieldset.querySelector('[data-price-label="max"]').textContent = hi === top ? fieldset.dataset.any : money(steps[hi]);
    fieldset.style.setProperty('--zardo-lo', (lo / top * 100) + '%');
    fieldset.style.setProperty('--zardo-hi', (hi / top * 100) + '%');
    if (write) {
      fieldset.querySelector('[name="filter.v.price.gte"]').value = lo ? String(steps[lo]) : '';
      fieldset.querySelector('[name="filter.v.price.lte"]').value = hi === top ? '' : String(steps[hi]);
    }
  };
  const zardoSyncPrice = (form) => {
    const fieldset = form && form.querySelector('[data-catalog-price]');
    if (!fieldset) return;
    const steps = zardoPriceSteps(Number(fieldset.dataset.cap) || 10000);
    const gte = Number(fieldset.querySelector('[name="filter.v.price.gte"]').value || 0);
    const lteValue = fieldset.querySelector('[name="filter.v.price.lte"]').value;
    let lo = 0;
    steps.forEach((step, index) => { if (step <= gte && index < steps.length - 1) lo = index; });
    const hi = lteValue === '' ? steps.length - 1 : Math.max(1, steps.findIndex((step) => step >= Number(lteValue)));
    fieldset.querySelector('[data-price-range="min"]').value = String(lo);
    fieldset.querySelector('[data-price-range="max"]').value = String(hi);
    zardoPricePaint(fieldset, false);
  };
  if (!window.zardoPriceBarReady) {
    window.zardoPriceBarReady = true;
    document.addEventListener('input', (event) => {
      const fieldset = event.target.closest && event.target.closest('[data-catalog-price]');
      if (fieldset && event.target.matches('[data-price-range]')) zardoPricePaint(fieldset, true);
    });
  }
  document.querySelectorAll('[data-catalog-price]').forEach((fieldset) => zardoSyncPrice(fieldset.closest('form')));
  const initializeCatalog = (section) => {
    if (!section.dataset.eraUrl || section.dataset.catalogReady) return;
    const main = document.querySelector('.shopify-section--main-collection');
    const dialog = section.querySelector('.zardo-catalog-filter');
    if (!main || !dialog) return;
    section.dataset.catalogReady = 'true';
    const mainId = main.id.replace('shopify-section-', '');
    const navigationId = section.closest('.shopify-section').id.replace('shopify-section-', '');
    const chooser = section.querySelector('.zardo-set-navigation__chooser');
    const all = section.querySelector('[data-catalog-all]');
    const status = section.querySelector('[data-catalog-status]');
    const retry = section.querySelector('[data-catalog-retry]');
    const cards = Array.from(section.querySelectorAll('[data-set-card]'));
    let scope = new URL(location.href);
    let request;
    let pending;
    let searchTimer;
    const indexCache = new Map();
    // Display-only grouping: authoritative types first; do not retag products.
    const catalogRank = (product) => {
      const type = (product.type || '').trim().toLowerCase();
      if (/^(?:graded card|slab|slabs)$/.test(type)) return 1;
      if (/^(?:single card|single|singles|jumbo card)$/.test(type)) return 2;
      if (/^(?:accessory|binder|empty booster box|video game|uncut sheet|master set|mystery bag)$/.test(type)) return 3;
      if (/^(?:blister|booster box|booster pack|build & battle|bundle|collection box|deck|elite trainer box|sealed case|sleeved booster pack|tin|upc\/spc)$/.test(type)) return 0;
      const text = `${product.title || ''} ${(product.tags || []).join(' ')}`.toLowerCase();
      if (/\b(?:graded\s*guards?|playmat|binder|empty\s+(?:booster\s+)?box|accessor(?:y|ies))\b/.test(text)) return 3;
      if (/\b(?:psa|bgs|cgc|sgc|ksa)(?=\b|\d)|\b(?:slabs?|graded card|beckett)\b/.test(text)) return 1;
      if (/\b(?:single(?: card)?s?|raw card|jumbo card)\b/.test(text)) return 2;
      if (/\b(?:booster (?:packs?|boxes?|bundles?)|blisters?|elite trainer box|etb|sealed case|collection box|build\s*(?:&|and)\s*battle|decks?|tins?|upc|spc)\b/.test(text)) return 0;
      if (/\(\d+\/[^)]+\)|\b(?:holofoil|reverse holo|non holo)\b/.test(text)) return 2;
      return 3;
    };
    const groupedOrder = (url) => !url.searchParams.get('sort_by') || url.searchParams.get('sort_by') === 'manual';
    const productLanguage = (product) => {
      const tags = (product.tags || []).join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/_/g, ' ').toLowerCase();
      const title = product.title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const text = `${title} ${tags}`;
      if (/\bjapanese\b|\bjaponais\b|\b(?:jp|jpn)\b|(?:language|langue|lang)[_:\s-]+ja\b/.test(text)) return 'ja';
      if (/\bfrench\b|\bfrancais\b|\(fr\)|(?:language|langue|lang)[_:\s-]+fr\b/.test(text)) return 'other';
      if (/\bkorean\b|\bchinese\b|\bgerman\b|\bitalian\b|\bspanish\b|\bportugu?ese\b|\bthai\b|\bindonesian\b|\(kr\)|\(cn\)|\(de\)|\(it\)|\(es\)|\(pt\)/.test(text)) return 'other';
      // Sets sortis seulement au Japon, nommes dans le titre (mesure 2026-10-23 : 14 slabs, aucun faux positif).
      if (/\b(?:shiny treasure|snow hazard|mega dream|dream league|tag bolt|terastal fest|super electric breaker|inferno x|vstar universe|eevee heroes|vmax climax|blue sky stream|skyscraping perfect|battle partners|heat wave arena|night wanderer|stellar miracle|paradise dragona|mask of change|cyber judge|wild force|crimson haze|clay burst|raging surf|ruler of the black flame|triplet beat|future flash|ancient roar|glory of team rocket|incandescent arcana|lost abyss|dark phantasma|time gazer|space juggler|star birth|fusion arts|matchless fighters|rapid strike master|single strike master|shiny star v|amazing volt tackle|vmax rising|explosive walker|legendary heartbeat|rebellion crash|infinity zone|tag all stars|remix bout|miracle twin|double blaze|gg end|sky legend|full metal wall|dark order|alter genesis|night unison|gx ultra shiny|hot wind arena|mega brave|mega symphonia|munikis zero|bonds to the end of time)\b/.test(title)) return 'ja';
      return 'en';
    };
    const parallel = async (items, fn) => {
      const results = new Array(items.length);
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(4, items.length) }, async () => {
        while (cursor < items.length) {
          const position = cursor++;
          results[position] = await fn(items[position]);
        }
      }));
      return results;
    };
    const languageResults = async (url, controller, parser, nextMain, nextNavigation) => {
      const language = url.searchParams.get('catalog_language');
      const query = (url.searchParams.get('catalog_q') || '').trim().slice(0, 120);
      const grouped = groupedOrder(url);
      if (!language && !query && !grouped) return;
      const base = new URL(url);
      ['catalog_language', 'catalog_page', 'catalog_q', 'catalog_set', 'catalog_tag', 'page', 'sections', 'section_id'].forEach(key => base.searchParams.delete(key));
      base.searchParams.set('view', 'zardo-catalog');
      if (grouped) base.searchParams.set('sort_by', 'manual');
      const key = base.href;
      let index = indexCache.get(key);
      if (!index || Date.now() - index.time > 300000) {
        const readIndex = async (page) => {
          const endpoint = new URL(base);
          endpoint.searchParams.set('section_id', 'zardo-catalog-language-index');
          endpoint.searchParams.set('page', page);
          const response = await fetch(endpoint, { signal: controller.signal });
          if (!response.ok) throw new Error('Language index unavailable');
          const element = parser.parseFromString(await response.text(), 'text/html').querySelector('[data-catalog-language-index]');
          if (!element) throw new Error('Language index missing');
          return JSON.parse(element.textContent);
        };
        const first = await readIndex(1);
        const rest = await parallel(Array.from({ length: Math.max(0, first.pages - 1) }, (_, i) => i + 2), readIndex);
        index = { time: Date.now(), products: [first, ...rest].flatMap(part => part.products) };
        indexCache.set(key, index);
      }
      const minimum = url.searchParams.get('filter.v.price.gte');
      const maximum = url.searchParams.get('filter.v.price.lte');
      const words = query.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().split(/\s+/).filter(Boolean);
      const matches = index.products.filter(product => {
        const wanted = { fr: 'other', unknown: 'en' }[language] || language;
        const languageMatches = !wanted || (wanted === 'not-ja' ? productLanguage(product) !== 'ja' : productLanguage(product) === wanted);
        const title = product.title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        return languageMatches && words.every(word => title.includes(word)) && (!minimum || product.price >= Math.round(Number(minimum) * 100)) && (!maximum || product.price <= Math.round(Number(maximum) * 100));
      });
      if (grouped) matches.sort((a, b) => catalogRank(a) - catalogRank(b));
      const currentPage = Math.max(1, Number.parseInt(url.searchParams.get('catalog_page') || (grouped ? url.searchParams.get('page') : null) || '1', 10) || 1);
      // 60 par page comme la grille normale : 60 se divise par 2, 3, 4 et 5, la derniere ligne est pleine.
      const selected = matches.slice((currentPage - 1) * 60, currentPage * 60);
      const pages = [...new Set(selected.map(product => product.page))];
      const rendered = await parallel(pages, async page => {
        if (page === 1) return nextMain;
        const endpoint = new URL(base);
        endpoint.searchParams.set('section_id', mainId);
        endpoint.searchParams.set('page', page);
        const response = await fetch(endpoint, { signal: controller.signal });
        if (!response.ok) throw new Error('Language products unavailable');
        return parser.parseFromString(await response.text(), 'text/html').getElementById(main.id);
      });
      const available = new Map(rendered.flatMap(part => Array.from(part.querySelectorAll('product-list > product-card')).map(card => [card.getAttribute('handle'), card])));
      const list = nextMain.querySelector('product-list');
      if (selected.length && !list) throw new Error('Language grid missing');
      if (list) list.replaceChildren(...selected.map(product => {
        const card = available.get(product.handle);
        if (!card) throw new Error('Language product missing');
        const clone = card.cloneNode(true);
        clone.dataset.catalogKind = ['sealed', 'slab', 'single', 'other'][catalogRank(product)];
        return clone;
      }));
      nextMain.querySelectorAll('.collection__pagination, .zardo-load-more-wrapper, .collection__empty').forEach(element => element.remove());
      if (!selected.length) nextMain.querySelector('.collection__results').appendChild(document.importNode(dialog.querySelector(query ? '[data-catalog-search-empty]' : '[data-catalog-empty]').content, true));
      if (matches.length > currentPage * 60) {
        const fragment = document.importNode(dialog.querySelector('[data-catalog-more]').content, true);
        const endpoint = new URL(url);
        endpoint.searchParams.set('view', 'zardo-catalog');
        endpoint.searchParams.set('catalog_page', currentPage + 1);
        fragment.querySelector('a').href = endpoint.href;
        nextMain.querySelector('.collection__results').appendChild(fragment);
      }
      nextNavigation.querySelector('.zardo-set-navigation__count strong').textContent = matches.length;
      return matches;
    };
    const validPath = (path) => path === section.dataset.eraUrl || cards.some(card => {
      const cardPath = new URL(card.href).pathname;
      return path === cardPath || path.startsWith(`${cardPath}/`);
    });
    const parameters = (url) => {
      const result = new URLSearchParams();
      url.searchParams.forEach((value, key) => {
        if (key.startsWith('filter.') || ['sort_by', 'page', 'catalog_language', 'catalog_page', 'catalog_q'].includes(key)) result.append(key, value);
      });
      return result;
    };
    const syncForm = () => {
      const form = dialog.querySelector('form');
      ['sort_by', 'filter.v.price.gte', 'filter.v.price.lte', 'catalog_language'].forEach(name => {
        const input = form.elements.namedItem(name);
        if (!input) return;
        const value = scope.searchParams.get(name);
        if (value !== null) input.value = value;
        else if (name === 'sort_by') input.value = 'manual';
        else if (input.tagName === 'INPUT' || name === 'catalog_language') input.value = '';
      });
      zardoSyncPrice(form);
    };
    const syncControls = () => {
      cards.forEach(card => {
        const path = new URL(card.href).pathname;
        const active = scope.pathname === path || scope.pathname.startsWith(`${path}/`);
        card.classList.toggle('is-active', active);
        if (active) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
      const isAll = scope.pathname === section.dataset.eraUrl;
      all.hidden = isAll;
      all.classList.toggle('is-active', isAll);
      all.setAttribute('aria-current', isAll ? 'true' : 'false');
      main.querySelector('.zardo-filter-control > button')?.setAttribute('aria-controls', dialog.id);
      const label = main.querySelector('.zardo-filter-control__state');
      if (label) {
        const sort = dialog.querySelector('[name="sort_by"]');
        const language = dialog.querySelector('[name="catalog_language"]:checked');
        label.textContent = (language?.value ? language.nextElementSibling?.textContent : sort?.selectedOptions[0]?.textContent) || '';
      }
      const query = scope.searchParams.get('catalog_q') || '';
      const state = section.querySelector('[data-catalog-query-state]');
      if (state) {
        state.hidden = !query;
        state.querySelector('[data-catalog-query-label]').textContent = query;
      }
      const input = section.querySelector('[data-catalog-query]');
      if (input && document.activeElement !== input) {
        input.value = query;
        input.dispatchEvent(new Event('catalog:sync-query'));
      }
      updateQueryClear();
    };
    const updateQueryClear = () => {
      const button = section.querySelector('[data-query-clear]');
      if (button) button.hidden = !section.querySelector('[data-catalog-query]').value;
    };
    const renderMatchingSets = matches => {
      const panel = section.querySelector('[data-catalog-matches]');
      if (!panel) return;
      const query = scope.searchParams.get('catalog_q');
      const links = panel.querySelector('[data-catalog-match-links]');
      links.replaceChildren();
      const counts = new Map();
      if (query) (matches || []).forEach(product => new Set(product.sets || []).forEach(handle => counts.set(handle, (counts.get(handle) || 0) + 1)));
      cards.forEach(card => {
        const handle = new URL(card.href).pathname.split('/').pop();
        if (!counts.has(handle)) return;
        const link = document.createElement('a');
        link.href = card.href;
        link.dataset.catalogMatchSet = 'true';
        const name = document.createElement('span');
        name.textContent = card.dataset.setTitle;
        const count = document.createElement('strong');
        count.textContent = counts.get(handle);
        link.append(name, count);
        links.appendChild(link);
      });
      panel.hidden = !links.children.length;
    };
    dialog.id = `catalog-filter-${navigationId}`;
    const load = async (source, { append = false, remember = true, closeChooser = false, replaceHistory = false } = {}) => {
      const url = new URL(source, location.origin);
      if (url.origin !== location.origin || !validPath(url.pathname)) return;
      request?.abort();
      const controller = request = new AbortController();
      pending = { url, options: { append, remember, closeChooser, replaceHistory } };
      status.hidden = false;
      status.querySelector('[data-catalog-message]').textContent = section.dataset.loading;
      retry.hidden = true;
      main.setAttribute('aria-busy', 'true');
      main.classList.add('is-loading');
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      try {
        const fetchUrl = new URL(url);
        if (url.searchParams.get('catalog_language') || url.searchParams.get('catalog_q') || groupedOrder(url)) fetchUrl.searchParams.delete('page');
        if (groupedOrder(url)) fetchUrl.searchParams.set('sort_by', 'manual');
        fetchUrl.searchParams.set('view', 'zardo-catalog');
        fetchUrl.searchParams.delete('section_id');
        fetchUrl.searchParams.set('sections', `${mainId},${navigationId}`);
        const response = await fetch(fetchUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('Catalog request failed');
        const sections = await response.json();
        if (!sections[mainId] || !sections[navigationId]) throw new Error('Catalog sections missing');
        const parser = new DOMParser();
        const nextMain = parser.parseFromString(sections[mainId], 'text/html').getElementById(main.id);
        const nextNavigation = parser.parseFromString(sections[navigationId], 'text/html').querySelector('.zardo-set-navigation');
        if (!nextMain?.querySelector('.collection__results') || !nextNavigation) throw new Error('Catalog results missing');
        const matches = await languageResults(url, controller, parser, nextMain, nextNavigation);
        if (controller.signal.aborted) return;
        main.dataset.catalogOrder = groupedOrder(url) ? 'grouped' : url.searchParams.get('sort_by');
        if (append) {
          const list = main.querySelector('product-list');
          const incoming = nextMain.querySelectorAll('product-list > *');
          if (!list || !incoming.length) throw new Error('Catalog page missing');
          incoming.forEach(card => list.appendChild(document.importNode(card, true)));
          const wrapper = main.querySelector('.zardo-load-more-wrapper');
          const nextWrapper = nextMain.querySelector('.zardo-load-more-wrapper');
          if (nextWrapper && wrapper) wrapper.replaceWith(document.importNode(nextWrapper, true));
          else wrapper?.remove();
        } else {
          main.replaceChildren(...document.importNode(nextMain, true).childNodes);
          const header = section.querySelector('.zardo-set-navigation__header');
          header.replaceChildren(...document.importNode(nextNavigation.querySelector('header'), true).childNodes);
          const viewing = section.querySelector('[data-catalog-current-view]');
          if (viewing) viewing.textContent = nextNavigation.querySelector('[data-catalog-current-view]').textContent;
          dialog.querySelector('form').replaceWith(document.importNode(nextNavigation.querySelector('[data-catalog-filter-form]'), true));
          scope = new URL(url);
          syncForm();
          syncControls();
          renderMatchingSets(matches);
          if (chooser.open) chooser.dispatchEvent(new Event('toggle'));
          if (closeChooser) {
            chooser.open = false;
            const search = section.querySelector('[data-set-search]');
            search.value = scope.searchParams.get('catalog_q') || '';
            search.dispatchEvent(new Event('catalog:sync-query'));
            chooser.querySelector('summary').focus({ preventScroll: true });
          }
          if (remember) {
            const browserUrl = new URL(location.href);
            ['catalog_set', 'catalog_tag'].forEach(key => browserUrl.searchParams.delete(key));
            Array.from(browserUrl.searchParams.keys()).forEach(key => {
              if (key.startsWith('filter.') || ['sort_by', 'page', 'catalog_language', 'catalog_page', 'catalog_q'].includes(key)) browserUrl.searchParams.delete(key);
            });
            parameters(scope).forEach((value, key) => browserUrl.searchParams.append(key, value));
            const parts = scope.pathname.split('/collections/')[1].split('/');
            browserUrl.searchParams.set('catalog_set', scope.pathname === section.dataset.eraUrl ? 'all' : parts[0]);
            if (parts[1]) browserUrl.searchParams.set('catalog_tag', parts[1]);
            history[replaceHistory ? 'replaceState' : 'pushState']({}, '', browserUrl);
          }
        }
        status.hidden = true;
      } catch (error) {
        if (request !== controller) return;
        status.querySelector('[data-catalog-message]').textContent = section.dataset.loadFailed;
        retry.hidden = false;
      } finally {
        window.clearTimeout(timeout);
        if (request === controller) {
          main.removeAttribute('aria-busy');
          main.classList.remove('is-loading');
        }
      }
    };
    const choose = (href, keepQuery = true) => {
      window.clearTimeout(searchTimer);
      const url = new URL(href, location.origin);
      url.search = parameters(scope).toString();
      url.searchParams.delete('page');
      url.searchParams.delete('catalog_page');
      if (!keepQuery) url.searchParams.delete('catalog_q');
      load(url, { closeChooser: true });
    };
    section.addEventListener('click', event => {
      const link = event.target.closest('[data-set-card], [data-catalog-all], [data-catalog-match-set], .zardo-set-navigation__version');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      choose(link.href, !link.hasAttribute('data-set-card'));
    });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('.zardo-filter-control > button');
      if (trigger && main.contains(trigger)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        syncForm();
        trigger.setAttribute('aria-expanded', 'true');
        dialog.showModal();
      }
      const button = event.target.closest('[data-zardo-load-more]');
      if (button && main.contains(button)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!main.hasAttribute('aria-busy')) load(button.href, { append: true, remember: false });
      }
    }, true);
    document.addEventListener('facet:update', event => {
      if (!main.contains(event.target)) return;
      event.stopImmediatePropagation();
      const url = new URL(event.detail.url);
      url.pathname = scope.pathname;
      if (scope.searchParams.get('catalog_language')) url.searchParams.set('catalog_language', scope.searchParams.get('catalog_language'));
      if (scope.searchParams.get('catalog_q')) url.searchParams.set('catalog_q', scope.searchParams.get('catalog_q'));
      url.searchParams.delete('catalog_page');
      load(url);
    }, true);
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-catalog-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
      if (event.target.closest('[data-catalog-clear]')) {
        const url = new URL(scope);
        Array.from(url.searchParams.keys()).forEach(key => {
          if (key.startsWith('filter.') || ['page', 'catalog_language', 'catalog_page'].includes(key)) url.searchParams.delete(key);
        });
        dialog.close();
        load(url);
      }
    });
    dialog.addEventListener('close', () => {
      const trigger = main.querySelector('.zardo-filter-control > button');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus({ preventScroll: true });
    });
    dialog.addEventListener('submit', event => {
      event.preventDefault();
      const form = event.target;
      const min = form.elements.namedItem('filter.v.price.gte');
      const max = form.elements.namedItem('filter.v.price.lte');
      if (min.value && max.value && Number(min.value) > Number(max.value)) {
        max.setCustomValidity(dialog.dataset.invalidPrice);
        max.reportValidity();
        return;
      }
      const url = new URL(scope);
      url.searchParams.delete('page');
      url.searchParams.delete('catalog_page');
      new FormData(form).forEach((value, key) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      dialog.close();
      load(url);
    });
    dialog.addEventListener('input', () => dialog.querySelector('[name="filter.v.price.lte"]').setCustomValidity(''));
    retry.addEventListener('click', () => load(pending.url, pending.options));
    const searchProducts = (query, wholeEra = true) => {
      window.clearTimeout(searchTimer);
      const url = new URL(scope);
      if (query && wholeEra) url.pathname = section.dataset.eraUrl;
      url.searchParams.delete('page');
      url.searchParams.delete('catalog_page');
      if (query.trim()) url.searchParams.set('catalog_q', query.trim().slice(0, 120));
      else url.searchParams.delete('catalog_q');
      load(url, { replaceHistory: Boolean(scope.searchParams.get('catalog_q')) });
    };
    const queryInput = section.querySelector('[data-catalog-query]');
    if (queryInput) {
      const clearQuery = () => {
        queryInput.value = '';
        queryInput.dispatchEvent(new Event('catalog:sync-query'));
        updateQueryClear();
        searchProducts('', false);
      };
      section.querySelector('[data-catalog-query-form]').addEventListener('submit', event => {
        event.preventDefault();
        searchProducts(queryInput.value);
      });
      queryInput.addEventListener('input', () => {
        updateQueryClear();
        window.clearTimeout(searchTimer);
        if (pending?.url.searchParams.get('catalog_q')) {
          request?.abort();
          request = undefined;
        }
        searchTimer = window.setTimeout(() => searchProducts(queryInput.value), 400);
      });
      queryInput.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); clearQuery(); }
      });
      section.querySelector('[data-query-clear]').addEventListener('click', () => { clearQuery(); queryInput.focus(); });
      section.querySelector('[data-catalog-query-reset]').addEventListener('click', clearQuery);
    }
    const restore = () => {
      const browserUrl = new URL(location.href);
      const handle = browserUrl.searchParams.get('catalog_set');
      let path = section.dataset.collectionUrl;
      if (handle === 'all') path = section.dataset.eraUrl;
      else if (handle) path = cards.map(card => new URL(card.href).pathname).find(path => path.endsWith(`/${handle}`)) || path;
      const tag = browserUrl.searchParams.get('catalog_tag');
      if (tag && /^[a-z0-9-]+$/.test(tag)) path += `/${tag}`;
      const url = new URL(path, location.origin);
      url.search = parameters(browserUrl).toString();
      if (handle || groupedOrder(url) || url.searchParams.get('catalog_q') || url.searchParams.get('catalog_language') || url.pathname !== scope.pathname || url.search !== scope.search) load(url, { remember: false });
    };
    scope.search = parameters(new URL(location.href)).toString();
    syncForm();
    syncControls();
    window.addEventListener('popstate', event => { event.stopImmediatePropagation(); restore(); }, true);
    restore();
  };
  const initializeSetSearch = (root) => {
    root.querySelectorAll('.zardo-set-navigation').forEach((section) => {
      const search = section.querySelector('[data-set-search]');
      if (!search || search.dataset.initialized) return;
      search.dataset.initialized = 'true';
      const rail = section.querySelector('.zardo-set-navigation__rail');
      const chooser = section.querySelector('.zardo-set-navigation__chooser');
      const paging = section.querySelector('[data-set-paging]');
      const previous = section.querySelector('[data-set-prev]');
      const next = section.querySelector('[data-set-next]');
      const clearSearch = section.querySelector('[data-set-clear]');
      const updatePaging = () => {
        if (!chooser.open) return;
        paging.hidden = rail.scrollWidth <= rail.clientWidth + 2;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      const pageStep = () => {
        const page = rail.querySelector('.zardo-set-navigation__page:not([hidden])');
        return page ? page.getBoundingClientRect().width + 12 : rail.clientWidth;
      };
      const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      previous.addEventListener('click', () => rail.scrollBy({ left: -pageStep(), behavior: scrollBehavior() }));
      next.addEventListener('click', () => rail.scrollBy({ left: pageStep(), behavior: scrollBehavior() }));
      rail.addEventListener('scroll', updatePaging, { passive: true });
      chooser.addEventListener('toggle', () => {
        const active = rail.querySelector('[aria-current]');
        if (chooser.open && !search.value && active) {
          const cardRect = active.getBoundingClientRect();
          const railRect = rail.getBoundingClientRect();
          rail.scrollTo({ left: rail.scrollLeft + cardRect.left - railRect.left - (rail.clientWidth - cardRect.width) / 2 });
        }
        updatePaging();
      });
      new ResizeObserver(updatePaging).observe(rail);
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const filterSets = () => {
        const query = normalize(search.value.trim());
        if (clearSearch) clearSearch.hidden = search.value.length === 0;
        let visible = 0;
        section.querySelectorAll('[data-set-card]').forEach((card) => {
          card.hidden = !normalize(card.dataset.setName).includes(query);
          if (!card.hidden) visible++;
        });
        const sharedSearch = section.querySelector('[data-catalog-query]');
        section.querySelector('[data-set-empty]').hidden = Boolean(sharedSearch) || visible > 0;
        const tools = section.querySelector('[data-catalog-set-tools]');
        if (tools) tools.hidden = Boolean(query) && visible === 0;
        const label = section.querySelector('[data-set-results-label]');
        if (label) label.hidden = !query || visible === 0;
        rail.dataset.matchCount = String(visible);
        rail.querySelectorAll('.zardo-set-navigation__page').forEach((page) => {
          const count = page.querySelectorAll('[data-set-card]:not([hidden])').length;
          page.hidden = count === 0;
          page.dataset.single = String(count === 1);
        });
        rail.scrollTo({left: 0});
        updatePaging();
      };
      search.addEventListener('input', filterSets);
      search.addEventListener('catalog:sync-query', filterSets);
      clearSearch?.addEventListener('click', () => {
        search.value = '';
        filterSets();
        search.focus();
      });
      filterSets();
      initializeCatalog(section);
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          search.value = '';
          filterSets();
        }
        if (event.key === 'Enter' && search.value.trim()) {
          const matches = section.querySelectorAll('[data-set-card]:not([hidden])');
          if (matches.length === 1) {
            event.preventDefault();
            matches[0].click();
          }
        }
      });
    });
  };
  initializeSetSearch(document);
  document.addEventListener('shopify:section:load', (event) => initializeSetSearch(event.target));

  } catch(e) { console.error(e); }
})();
})();
